__turbopack_context__.v({
  "back": "mouse-module__7pLy8W__back",
  "description": "mouse-module__7pLy8W__description",
  "flex": "mouse-module__7pLy8W__flex",
  "heading": "mouse-module__7pLy8W__heading",
  "headingIcon": "mouse-module__7pLy8W__headingIcon",
  "mouse": "mouse-module__7pLy8W__mouse",
  "shell": "mouse-module__7pLy8W__shell",
  "title": "mouse-module__7pLy8W__title",
});
